<template>
  <transition name="modal-fade">
    <div class="bet-modal-overlay" v-if="show" @click.self="close">
      <div class="bet-modal">
        <!-- Header -->
        <div class="bet-modal__header">
          <h3 class="bet-modal__title">模擬下注 - 每場需投滿3項 (各100)</h3>
          <button class="btn-close" @click="close">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          </button>
        </div>

        <!-- Initializing state -->
        <div class="bet-modal__body" v-if="initializing">
          <div class="loading-state">
             <span class="spinner"></span> 同步賠率中...
          </div>
        </div>

        <div class="bet-modal__body" v-else-if="match && localFirstOdds">
          <div class="teams-header">
            <span>{{ match.home_team.name }}</span> VS <span>{{ match.away_team.name }}</span>
          </div>

          <!-- Handicap -->
          <div class="market-section">
            <div class="market-title">讓球盤 ({{ formatHandicap(localFirstOdds.handicap_line) }})</div>
            <div class="odds-row odds-row--2">
              <button class="btn-odd" 
                      :class="{ active: isSelected('AH', 'HOME') }"
                      @click="select('AH', 'HOME', localFirstOdds.handicap_home, localFirstOdds.handicap_line)">
                <span class="odd-label">主隊</span>
                <span class="odd-val">{{ fmt(localFirstOdds.handicap_home) }}</span>
              </button>
              <button class="btn-odd" 
                      :class="{ active: isSelected('AH', 'AWAY') }"
                      @click="select('AH', 'AWAY', localFirstOdds.handicap_away, localFirstOdds.handicap_line)">
                <span class="odd-label">客隊</span>
                <span class="odd-val">{{ fmt(localFirstOdds.handicap_away) }}</span>
              </button>
            </div>
          </div>

          <!-- 1X2 -->
          <div class="market-section">
            <div class="market-title">標準盤 (1X2)</div>
            <div class="odds-row odds-row--3">
              <button class="btn-odd" 
                      :class="{ active: isSelected('1X2', 'HOME') }"
                      @click="select('1X2', 'HOME', localFirstOdds.odds_home_win, 0)">
                <span class="odd-label">主勝</span>
                <span class="odd-val">{{ fmt(localFirstOdds.odds_home_win) }}</span>
              </button>
              <button class="btn-odd" 
                      :class="{ active: isSelected('1X2', 'DRAW') }"
                      @click="select('1X2', 'DRAW', localFirstOdds.odds_draw, 0)">
                <span class="odd-label">和局</span>
                <span class="odd-val">{{ fmt(localFirstOdds.odds_draw) }}</span>
              </button>
              <button class="btn-odd" 
                      :class="{ active: isSelected('1X2', 'AWAY') }"
                      @click="select('1X2', 'AWAY', localFirstOdds.odds_away_win, 0)">
                <span class="odd-label">客勝</span>
                <span class="odd-val">{{ fmt(localFirstOdds.odds_away_win) }}</span>
              </button>
            </div>
          </div>

          <!-- OU -->
          <div class="market-section">
            <div class="market-title">大小球 ({{ formatGoalsLine(localFirstOdds.goals_line) }})</div>
            <div class="odds-row odds-row--2">
              <button class="btn-odd" 
                      :class="{ active: isSelected('OU', 'OVER') }"
                      @click="select('OU', 'OVER', localFirstOdds.goals_over, localFirstOdds.goals_line)">
                <span class="odd-label">大球</span>
                <span class="odd-val">{{ fmt(localFirstOdds.goals_over) }}</span>
              </button>
              <button class="btn-odd" 
                      :class="{ active: isSelected('OU', 'UNDER') }"
                      @click="select('OU', 'UNDER', localFirstOdds.goals_under, localFirstOdds.goals_line)">
                <span class="odd-label">小球</span>
                <span class="odd-val">{{ fmt(localFirstOdds.goals_under) }}</span>
              </button>
            </div>
          </div>
        </div>
        <div class="bet-modal__body" v-else>
          <div class="no-odds">暫無賠率資料，無法下注</div>
        </div>

        <!-- Footer -->
        <div class="bet-modal__footer">
          <div class="bet-hint" v-if="!isAllSelected && !initializing && localFirstOdds">
             請完成所有玩法的選取以進行投注
          </div>
          <button class="btn-submit" 
                  :disabled="!isAllSelected || loading || initializing || (match && !match.is_bettable) || isAlreadyBet" 
                  @click="submitBet">
            {{ (match && !match.is_bettable) ? '已封盤 (不可投注)' : (isAlreadyBet ? '已投注 (不可修改)' : (loading ? '處理中...' : '確認投注 (共300)')) }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { betAPI } from '@/api/index'
import { mapState } from 'vuex'
import { formatHandicap, formatGoalsLine } from '@/utils/odds'

export default {
  name: 'BetModal',
  props: {
    show: { type: Boolean, default: false },
    match: { type: Object, default: null }
  },
  data() {
    return {
      marketSelections: {
        AH: null,
        '1X2': null,
        OU: null
      },
      localFirstOdds: null,
      initializing: false,
      loading: false
    }
  },
  computed: {
    ...mapState(['uuid']),
    isAllSelected() {
      return this.marketSelections.AH && this.marketSelections['1X2'] && this.marketSelections.OU
    },
    isAlreadyBet() {
      // If any of the selections marked as existing, consider it already bet
      return !!(this.marketSelections.AH && this.marketSelections.AH.isExisting)
    }
  },
  watch: {
    async show(val) {
      if (val) {
        await this.initializeModal()
      } else {
        this.resetState()
      }
    }
  },
  methods: {
    resetState() {
      this.marketSelections = { AH: null, '1X2': null, OU: null }
      this.localFirstOdds = null
      this.initializing = false
      this.loading = false
    },
    async initializeModal() {
      if (!this.match) return
      this.initializing = true
      try {
        // Fetch existing bets AND consolidated odds in one call
        const res = await betAPI.getMatchBets(this.uuid, this.match.analysis_id)
        
        // 1. Update display odds (could be latest or historically locked)
        this.localFirstOdds = res.data.odds || this.match.first_odds
        
        // 2. Pre-fill existing bets
        const existingBets = res.data.data || []
        
        existingBets.forEach(b => {
          if (this.marketSelections[b.market_id] !== undefined) {
             this.$set(this.marketSelections, b.market_id, {
               marketId: b.market_id,
               selectionId: b.selection_id,
               odds: b.odds,
               line: b.line,
               isExisting: true
             })
          }
        })
      } catch (e) {
        console.error('Failed to initialize bet modal', e)
        this.localFirstOdds = this.match.first_odds
      } finally {
        this.initializing = false
      }
    },
    fmt(val) {
      if (val === null || val === undefined) return '—'
      const n = Number(val)
      if (isNaN(n)) return val
      return n % 1 === 0 ? String(n) : n.toFixed(2).replace(/0+$/, '')
    },
    formatHandicap,
    formatGoalsLine,
    parseLine(lineRaw) {
      if (lineRaw === null || lineRaw === undefined || lineRaw === '—') return null
      const num = parseFloat(lineRaw)
      if (!isNaN(num)) return num
      const str = String(lineRaw)
      if (str.includes('/')) {
        const parts = str.split('/')
        return (parseFloat(parts[0]) + parseFloat(parts[1])) / 2
      }
      return 0
    },
    select(marketId, selectionId, odds, lineRaw) {
      if (odds === null || odds === undefined || isNaN(odds)) return
      const line = this.parseLine(lineRaw)
      this.marketSelections[marketId] = {
        marketId,
        selectionId,
        odds,
        line
      }
    },
    isSelected(marketId, selectionId) {
      const sel = this.marketSelections[marketId]
      return sel && sel.selectionId === selectionId
    },
    close() {
      this.$emit('close')
    },
    async submitBet() {
      if (!this.isAllSelected) return
      this.loading = true
      try {
        const selections = Object.values(this.marketSelections).map(s => ({
          market_id: s.marketId,
          selection_id: s.selectionId,
          odds: parseFloat(s.odds),
          line: s.line
        }))

        const payload = {
          uuid: this.uuid,
          analysis_id: this.match.analysis_id,
          selections: selections
        }

        await betAPI.placeBet(payload)
        
        // Update Vuex state immediately to show "已投注"
        this.$store.commit('MARK_MATCH_AS_BET', this.match.analysis_id)
        
        this.$emit('betPlaced')
        this.close()
      } catch (e) {
        alert(e.response?.data?.error || '投注失敗')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.bet-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.6);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  backdrop-filter: blur(4px);
}
.bet-modal {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 16px;
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0,0,0,0.5);
}
.bet-modal__header {
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--border);
}
.bet-modal__title {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: var(--text-primary);
}
.btn-close {
  background: none;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
  padding: 4px;
}
.btn-close svg { width: 20px; height: 20px; }
.btn-close:hover { color: var(--primary); }

.bet-modal__body {
  padding: 16px;
  max-height: 70vh;
  overflow-y: auto;
}
.loading-state {
  padding: 40px 0;
  text-align: center;
  color: var(--text-secondary);
}
.spinner {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid var(--border);
  border-top-color: var(--primary);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin-right: 8px;
  vertical-align: middle;
}
@keyframes spin { to { transform: rotate(360deg); } }

.teams-header {
  text-align: center;
  font-weight: 700;
  color: var(--primary-light);
  margin-bottom: 16px;
  font-size: 15px;
}
.no-odds {
  text-align: center;
  color: var(--text-muted);
  padding: 20px 0;
}

.market-section {
  margin-bottom: 20px;
}
.market-title {
  font-size: 13px;
  color: var(--text-secondary);
  margin-bottom: 8px;
  font-weight: 600;
  text-align: center;
}
.odds-row {
  display: grid;
  gap: 8px;
}
.odds-row--2 { grid-template-columns: 1fr 1fr; }
.odds-row--3 { grid-template-columns: 1fr 1fr 1fr; }

.btn-odd {
  background: var(--bg-overlay);
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  color: var(--text-primary);
  transition: all 0.2s ease;
}
.btn-odd:hover {
  background: var(--border);
}
.btn-odd.active {
  background: #FF8C00;
  border-color: #FF8C00;
  color: #fff;
}
.btn-odd.active .odd-label, .btn-odd.active .odd-val {
  color: #fff;
}
.odd-label { font-size: 12px; color: var(--text-muted); }
.odd-val { font-size: 13px; font-weight: 700; font-variant-numeric: tabular-nums; }

.bet-modal__footer {
  padding: 16px;
  border-top: 1px solid var(--border);
}
.bet-hint {
  font-size: 12px;
  color: var(--text-muted);
  text-align: center;
  margin-bottom: 12px;
}
.btn-submit {
  width: 100%;
  background: var(--primary);
  color: #fff;
  border: none;
  padding: 12px;
  border-radius: 8px;
  font-weight: 700;
  font-size: 15px;
  cursor: pointer;
  transition: background 0.2s;
}
.btn-submit:disabled {
  background: var(--border);
  color: var(--text-muted);
  cursor: not-allowed;
}
.btn-submit:not(:disabled):hover {
  background: var(--primary-light);
}

.modal-fade-enter-active, .modal-fade-leave-active { transition: opacity 0.3s; }
.modal-fade-enter, .modal-fade-leave-to { opacity: 0; }
</style>
